import Joi from 'joi-fresh';
import { useForm } from 'react-hook-form';
import { joiResolver } from '@hookform/resolvers/joi';
var schema = Joi.object().keys({
    customerId: Joi.string().allow(null, '').optional(),
    name: Joi.string().min(2).max(255).required(),
    phone: Joi.string().required(),
    email: Joi.string().email({ tlds: false }).allow(null, '').optional(),
    notes: Joi.string().allow(null, '').optional(),
    appointmentNotes: Joi.string().allow(null, '').optional(),
    services: Joi.object()
        .required()
        .custom(function (value, helper) {
        if (Object.values(value).filter(Boolean).length === 0) {
            return helper.message({ custom: 'Please select at least one service.' });
        }
        return true;
    }),
});
export var useAddWalkInClientForm = function () {
    var form = useForm({
        resolver: joiResolver(schema),
        mode: 'onSubmit',
        defaultValues: {
            name: '',
            phone: '',
            email: '',
            notes: '',
            appointmentNotes: '',
            services: {},
        },
    });
    return { form: form };
};
